<script lang="ts">
  import { Col, Image, Row } from "sveltestrap";
  import { Creditcard } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
  import CreditcardForm from "./CreditcardForm.svelte";
  let imgPath:string = "/assets/images/ecommerce"
</script>
<Col xxl="8" class="box-col-12">
  <Card cardHeaderprops="pb-0" headerTitle={Creditcard}>
    <div slot="contentbody">
      <Row>
        <Col md="7">
          <CreditcardForm />
        </Col>
        <Col md="5" class="text-center">
          <Image fluid src="{imgPath}/card.png" />
        </Col>
      </Row>
    </div>
  </Card>
</Col>